import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity'
import Headline from 'components/atoms/headline/Headline'
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen'
import DashboardBoxTitle from 'components/atoms/title/DashboardBoxTitle'
import Table from 'components/molecules/table/Table'
import DashboardBoxLayout from 'components/templates/dashboard-box-layout/DashboardBoxLayout'
import { leaveRequestsAdminHeaders } from 'lib/helpers/constants/columns/leaveRequestsAdminHeaders'
import { usePendingAbsenceRequests } from 'lib/hooks/queries/Employee/usePendingAbsenceRequests'
import React from 'react'

const EmployeeAbsencesView = () => {

   

    const { data, isLoading } = usePendingAbsenceRequests()


    return (
        <div>
            <Headline title='Absences' />
            <DashboardBoxLayout>
                <div className="mb-5">

                    <DashboardBoxTitle title='Manage Absences' />
                </div>
               
                <div>
                    {isLoading ? (
                        <div className='relative py-20'>
                            <LoadingScreen />
                        </div>
                    ) : (
                        (data as any)?.data?.length === 0 ? (
                            <EmptyEntity 
                                name='Absences'
                            />
                        ) : (
                            <Table
                                columns={leaveRequestsAdminHeaders}
                                data={(data as any)?.data}
                                search=''
                            />
                        )
                    )}
                </div>
            </DashboardBoxLayout>
        </div>
    )
}

export default EmployeeAbsencesView